<template>
    <v-card elevation="2" class="pa-4">
        <div class="table-wrapper">
            <table class="custom-table">
                <thead>
                    <tr>
                        <th v-for="header in headers" :key="header.value">
                            {{ header.text }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in searchedCustomers" :key="item.CustomerGUID" class="table-row">
                        <template v-if="editingItem && editingItem.CustomerGUID === item.CustomerGUID">
                            <td>
                                <v-text-field v-model="editingItem.Company_Name" dense hide-details
                                    variant="underlined" />
                            </td>
                            <td>
                                <v-text-field v-model="editingItem.Country" dense hide-details variant="underlined" />
                            </td>
                            <td>
                                <v-text-field v-model="editingItem.Business_Number" dense hide-details
                                    variant="underlined" />
                            </td>
                            <td>
                                <v-text-field v-model="editingItem.Currency" dense hide-details variant="underlined" />
                            </td>
                            <td>
                                <v-text-field v-model="editingItem.Primary_Contact_Email" dense hide-details
                                    variant="underlined" />
                            </td>
                            <td>
                                <v-text-field v-model="editingItem.Primary_Contact_Phone" dense hide-details
                                    variant="underlined" />
                            </td>
                            <td class="actions-cell">
                                <v-btn icon="mdi-check" color="success" @click="saveItem(editingItem)" variant="text"
                                    size="small" />
                                <v-btn icon="mdi-close" color="error" @click="cancelEdit" variant="text" size="small" />
                            </td>
                        </template>
                        <template v-else>
                            <td>
                                <router-link :to="`/partner/customer`" class="customer-link"
                                    @click="storeCustomerDetails(item)">
                                    {{ item.Company_Name }}
                                </router-link>
                            </td>
                            <td>{{ item.Country }}</td>
                            <td>{{ item.Business_Number || '—' }}</td>
                            <td>{{ item.Currency }}</td>
                            <td>{{ item.Primary_Contact_Email }}</td>
                            <td>{{ item.Primary_Contact_Phone }}</td>
                            <!-- <td class="actions-cell">
                                <v-btn icon color="primary" @click="editItem(item)" variant="text" size="small">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon color="error" @click="deleteItem(item)" variant="text" size="small">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </td> -->
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Loading Message -->
        <v-alert v-if="customers.length === 0" type="info" class="mt-4" text>
            Loading customers or no data available.
        </v-alert>

        <!-- Pagination -->
        <v-card-actions class="d-flex justify-space-between align-center mt-4">
            <span class="text-caption">
                Showing {{ Math.min((page - 1) * itemsPerPage + 1, filteredCustomers.length) }} -
                {{ Math.min(page * itemsPerPage, filteredCustomers.length) }} of {{ filteredCustomers.length }}
            </span>
            <v-pagination v-model="page" :length="pageCount" density="compact" />
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'CustomerTable',
    props: {
        search: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            page: 1,
            editingItem: null,
            itemsPerPage: 6,
            headers: [
                { text: 'Customer', value: 'Company_Name' },
                { text: 'Country', value: 'Country' },
                { text: 'Business Number', value: 'Business_Number' },
                { text: 'Currency', value: 'Currency' },
                { text: 'Email', value: 'Primary_Contact_Email' },
                { text: 'Phone', value: 'Primary_Contact_Phone' }
                // { text: 'Actions', value: 'actions' },
            ],
            customers: [],
        };
    },
    computed: {
        filteredCustomers() {
            const searchLower = this.search.toLowerCase();
            return this.search
                ? this.customers.filter(c =>
                    (c.Company_Name && c.Company_Name.toLowerCase().includes(searchLower)) ||
                    (c.Country && c.Country.toLowerCase().includes(searchLower))
                )
                : this.customers;
        },
        searchedCustomers() {
            const start = (this.page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredCustomers.slice(start, end);
        },
        pageCount() {
            return Math.ceil(this.filteredCustomers.length / this.itemsPerPage);
        },
    },
    methods: {
        fetchCustomers() {
            const payload = {
                partnerGUID: localStorage.getItem('partnerGuid') || '',
            };

            fetch(process.env.VUE_APP_VORTEX_PORTAL_WS + '/customers/all', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then(response => response.json())
                .then(data => {
                    this.customers = data.customers || [];
                })
                .catch(error => {
                    console.error('API fetch error:', error);
                });
        },
        editItem(item) {
            this.editingItem = { ...item };
        },
        saveItem(editedItem) {
            const index = this.customers.findIndex(c => c.CustomerGUID === editedItem.CustomerGUID);
            if (index !== -1) {
                this.customers[index] = { ...editedItem };
            }
            this.editingItem = null;
        },
        cancelEdit() {
            this.editingItem = null;
        },
        deleteItem(itemToDelete) {
            const index = this.customers.findIndex(c => c.CustomerGUID === itemToDelete.CustomerGUID);
            if (index !== -1) {
                this.customers.splice(index, 1);
            }
        },
        storeCustomerDetails(item) {
            localStorage.setItem('customerName', item.Company_Name);
            localStorage.setItem('customerGUID', item.CustomerGUID);
            localStorage.setItem('customerCountry', item.Country);
            localStorage.setItem('customerBusinessNumber', item.Business_Number);
            localStorage.setItem('customerEmail', item.Primary_Contact_Email);
            localStorage.setItem('customerPhone', item.Primary_Contact_Phone);
        }
    },
    mounted() {
        this.fetchCustomers();
    },
};
</script>

<style scoped>
.table-wrapper {
    overflow-x: auto;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;
}

.custom-table th,
.custom-table td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    white-space: nowrap;
    font-size: 14px;
}

.custom-table th {
    background-color: #f4f4f4;
    font-weight: 600;
    color: #333;
}

.custom-table td:last-child {
    text-align: center;
}

.actions-cell {
    white-space: nowrap;
    width: 120px;
}

.customer-link {
    color: inherit;
    text-decoration: none;
    font-weight: 500;
    display: inline-block;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 4px 8px;

    /* Search Bar */
    .search-section {
        margin-bottom: 20px;
        padding: 10px;
        background-color: #f8f8f8;
        border-radius: 8px;
    }

    border-radius: 6px;
}

.customer-link:hover {
    color: #e45f2b;
    text-decoration: underline;
    background-color: #f5f5f5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
</style>
